"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var index_1 = require("../../styled/index");
var index_2 = require("../../theme/index");
var InProgressText = function (_a) {
    var children = _a.children;
    return React.createElement(Wrapper, null, children);
};
var Wrapper = index_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  animation: flash linear 3s infinite;\n  @keyframes flash {\n    0% {\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.1;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  text-align: center;\n  font-size: ", ";\n  color: ", ";\n  font-weight: 700;\n"], ["\n  animation: flash linear 3s infinite;\n  @keyframes flash {\n    0% {\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.1;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  text-align: center;\n  font-size: ", ";\n  color: ", ";\n  font-weight: 700;\n"])), index_2.fontSize.body, function (props) { return props.theme.colors.success; });
exports.default = InProgressText;
var templateObject_1;
//# sourceMappingURL=InProgressText.js.map